var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.480469,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#1C1C1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_5006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.4805H20V22.4805C20 23.0328 19.5523 23.4805 19 23.4805H13C12.4477 23.4805 12 23.0328 12 22.4805V13.4805Z",
    stroke: "#636366",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 13.4805H10",
    stroke: "#636366",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 12.4805V11.4805C19 10.3759 18.1046 9.48047 17 9.48047H15C13.8954 9.48047 13 10.3759 13 11.4805V12.4805",
    stroke: "#636366",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16.4805L16 20.4805",
    stroke: "#636366",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_5006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8.48047)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCart);
export default __webpack_public_path__ + "static/media/delete_cart.39063c45bbcb49c3dc6bb1bd31aa4de9.svg";
export { ForwardRef as ReactComponent };